var map = {
	"./icon-type-1.png": "c5b5",
	"./icon-type-2.png": "aec5",
	"./icon-type-3.png": "71a1",
	"./icon-type-4.png": "4005",
	"./icon-type-5.png": "b029",
	"./icon-type-6.png": "0d3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "514d";